import { ACCESS_DENIED } from '@/constants/routes';
import abilityFor from '@/config/ability';
import { useUserStore } from '@/stores/user';

export default function canAbility(actions, subject) {
  return () => {
    const userStore = useUserStore();
    const abilities = abilityFor(userStore.role, userStore.rights);

    if (actions.some(action => abilities.can(action, subject))) {
      return true;
    }

    return { name: ACCESS_DENIED };
  };
}
